export default "__VITE_ASSET__B$BFZmTr__"